import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { object, number, string } from "prop-types";
import { StoryElement, WithLazy } from "@quintype/components";

import Tags from "../story-elements/tags";
import MoreNews from "../story-elements/more-news";
import AlsoRead from "../story-elements/also-read";
import Slideshow from "../story-elements/slide-show";
import Attachment from "../story-elements/attachment";
import FactCheckView from "../story-elements/fact-check";
import PodcastBody from "../story-elements/podcast-body";
import ImageGallery from "../story-elements/image-gallery";
import SponsoredTag from "../story-elements/sponsored-tag";
import MovieReviewView from "../story-elements/movie-review";
import GadgetReviewView from "../story-elements/gadget-review";
import ReferenceElement from "../story-elements/reference-element";

import ImagewithCaptionWithoutShare from "../../molecules/image-without-share";

import { AdContainer } from "../../ads";
import TaboolaAd from "../../ads/taboola-ad";
import NewBodyWidget from "../../atoms/new-body-banner";

import BlockQuoteIcon from "../../atoms/icons/blockquote-icon";
import PromotionalMessage from "./promotional-message";
import ImagewithCaption from "../../molecules/Image-caption";

import LatestNews from "./latest-news";
import useDevice from "../../helper/custom-hook/useDevice";
import useAdType from "../../helper/custom-hook/useAdType";

import "./story-elements.m.css";
import QandA from "./q-and-a";

let countPara = 0;
let hasRenderedMidAd1 = false;
let hasRenderedMidAd2 = false;
const getParagraphsArr = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const elements = [...doc.body.children];
  return elements.map((el) => el.outerHTML);
};

const CustomStoryElement = ({ element, adType, story }) => {
  const rawHtml = element && element.text;
  const [paragraphs, setParagraphs] = useState([]);
  const [isWebView, setIsWebView] = useState(false);
  const storyTemplate = story && story["story-template"];
  const blockedTemplates = ["listicle", "live-blog"];
  useEffect(() => {
    if (typeof window !== "undefined") {
      const searchparam = window.location.search;
      if (!searchparam.includes("app=true")) {
        setIsWebView(true);
      }
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = rawHtml;
      const paragraphElements = getParagraphsArr(rawHtml);
      const parsedParagraphs =
        paragraphElements !== null &&
        paragraphElements.map((p, index) => {
          const tempElement = document.createElement("div");
          tempElement.innerHTML = p;
          // Check if the element contains a <p> tag
          const hasPTag = tempElement.getElementsByTagName("p").length > 0;
          if (hasPTag) {
            countPara = countPara + 1;
          }

          if (countPara > 0 && countPara === 4 && !hasRenderedMidAd2) {
            hasRenderedMidAd2 = true;
            return (
              <div key={index}>
                <div className="story-element story-element-text" dangerouslySetInnerHTML={{ __html: p }}></div>
                {!isWebView && (story["story-template"] === "text" || story["story-template"] === "syndicated") && (
                  <div styleName="ad-wrapper" className="hide-desktop">
                    <AdContainer
                      AdClassName="standard-336x280"
                      id="div-gpt-ad-1727945329402-0"
                      desktop={false}
                      mobile="PV_MWeb_AT_Mid02"
                    />
                  </div>
                )}
              </div>
            );
          }
          if (!blockedTemplates.includes(storyTemplate) && countPara > 0 && countPara === 1 && !hasRenderedMidAd1) {
            hasRenderedMidAd1 = true;
            return (
              <React.Fragment key={index}>
                <div>
                  <div className="story-element story-element-text" dangerouslySetInnerHTML={{ __html: p }}></div>
                </div>
                <NewBodyWidget />
                {storyTemplate !== "podcast" && (
                  <div className="hide-desktop">
                    <AdContainer
                      AdClassName="standard-336x280"
                      id={adType === "izooto" ? "div-gpt-ad-1711631172416-0" : "div-gpt-ad-1675837516069-0"}
                      mobile={adType === "izooto" ? "PV_MWeb_AP_Mid_ym" : "PV_MWeb_AP_Mid"}
                      isExternalAdPath={adType === "izooto"}
                    />
                  </div>
                )}
                <div className="hide-mobile">
                  <AdContainer
                    AdClassName="standard-336x280"
                    id={adType === "izooto" ? "div-gpt-ad-1711630758806-0" : "div-gpt-ad-1675837175211-0"}
                    desktop={adType === "izooto" ? "PV_Desktop_AP_Mid_ym" : "PV_Desktop_AP_Mid"}
                    isExternalAdPath={adType === "izooto"}
                  />
                </div>
              </React.Fragment>
            );
          }
          return (
            <div key={index}>
              <div className="story-element story-element-text" dangerouslySetInnerHTML={{ __html: p }}></div>
            </div>
          );
        });
      setParagraphs(parsedParagraphs);
    }
  }, []);

  return <div>{paragraphs}</div>;
};
CustomStoryElement.propTypes = {
  element: object,
  elementIndex: number,
  adType: string,
  story: object
};
const getElements = (element, story, elementIndex, adType, isMobile) => {
  const elementType = element.type;

  if (element.metadata?.["promotional-message"] === true) {
    return null;
  }

  if (element.type === "text" && element.subtype === null) {
    return (
      <div id="text-element-with-ad">
        <CustomStoryElement
          element={element}
          elementIndex={elementIndex}
          adType={adType}
          isMobile={isMobile}
          story={story}
        />
      </div>
    );
  }
  switch (element.subtype) {
    case "attachment": {
      return <Attachment element={element} />;
    }
    case "references": {
      const referenceObj = get(element, ["story-elements"], []);
      return referenceObj.map((element, index) => <ReferenceElement element={element} key={index} />);
    }
    case "image-gallery": {
      if (element.metadata.type === "gallery") {
        return <WithLazy margin="50px">{() => <ImageGallery element={element} story={story} />}</WithLazy>;
      }

      if (element.metadata.type === "slideshow") {
        return <WithLazy margin="50px">{() => <Slideshow story={story} element={element} />}</WithLazy>;
      }
      break;
    }
    case "blockquote": {
      return (
        <div styleName="blockquote-wrapper">
          <BlockQuoteIcon />
          <StoryElement element={element} key={element.id} story={story} />
        </div>
      );
    }
    case "quote": {
      return (
        <div styleName="quote-wrapper" className="exclusive-wrapper">
          <div styleName="quote-contents" className="exclusive-contents">
            <img src="/icons/quoteicon.png" styleName="quote-icon" />
            <StoryElement element={element} key={element.id} story={story} />
          </div>
        </div>
      );
    }
    case "also-read": {
      return <AlsoRead element={element} story={story} />;
    }
    case "q-and-a": {
      return <QandA element={element} story={story} subtype={element.subtype} />;
    }
    case "question": {
      return <QandA element={element} story={story} subtype={element.subtype} />;
    }
    case "answer": {
      return <QandA element={element} story={story} subtype={element.subtype} />;
    }
    case "table": {
      if (element.metadata["has-header"] == true) {
        const updateEle = { ...element };
        updateEle.metadata["has-header"] = false;
        return (
          <div className="has-head story-element story-element-data">
            <StoryElement element={updateEle} key={updateEle.id} story={story} />;
          </div>
        );
      } else {
        return <StoryElement element={element} key={element.id} story={story} />;
      }
    }
    default:
      if (elementType === "image") {
        if (story["story-template"] === "photo") {
          return (
            <div styleName="share-wrapper">
              {story["story-template"] === "photo" && elementType === "image" && (
                <StoryElement
                  renderTemplates={{ image: ImagewithCaption }}
                  element={element}
                  key={element.id}
                  story={story}
                />
              )}
            </div>
          );
        } else {
          return (
            <StoryElement
              renderTemplates={{ image: ImagewithCaptionWithoutShare }}
              element={element}
              key={element.id}
              story={story}
            />
          );
        }
      } else {
        return (
          <div styleName="share-wrapper">
            {story["story-template"] !== "podcast" ? (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            ) : elementType !== "jsembed" ? (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            ) : element.subtype === "" || element.subtype === null ? (
              console.log("element.subtype ignored:>:>:>:>:>", elementType, element.subtype)
            ) : (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            )}
          </div>
        );
      }
  }
};

export const StoryCard = ({ story, card, cardIndex, adType, index }) => {
  const elements = card["story-elements"];
  const isMobile = useDevice();
  const wrappedAllElementCard = (elements, story) => {
    let allAlsoReads = [];
    const allWrappedElements = [];

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];

      if (element.subtype === "also-read") {
        allAlsoReads.push(element);
      } else {
        if (allAlsoReads.length > 1) {
          allWrappedElements.push(
            <div styleName="also-read-main-wrapper" key={`also-read-wrapper-${i}`}>
              {allAlsoReads.map((element, elementIndex) => (
                <AlsoRead
                  key={elementIndex}
                  story={story}
                  element={element}
                  isConsecutive={true}
                  elementIndex={elementIndex}
                />
              ))}
            </div>
          );
        } else {
          allWrappedElements.push(
            ...allAlsoReads.map((element, elementIndex) => (
              <AlsoRead
                key={elementIndex}
                story={story}
                element={element}
                isConsecutive={false}
                elementIndex={elementIndex}
              />
            ))
          );
        }

        allAlsoReads = [];
        allWrappedElements.push(getElements(element, story, i, adType, isMobile));
      }
    }
    if (allAlsoReads.length > 1) {
      allWrappedElements.push(
        <div styleName="also-read-main-wrapper" key="also-read-wrapper-end">
          {allAlsoReads.map((element, elementIndex) => (
            <AlsoRead
              key={elementIndex}
              story={story}
              element={element}
              isConsecutive={true}
              elementIndex={elementIndex}
            />
          ))}
        </div>
      );
    } else {
      allWrappedElements.push(
        ...allAlsoReads.map((element, elementIndex) => (
          <AlsoRead
            key={elementIndex}
            story={story}
            element={element}
            isConsecutive={false}
            elementIndex={elementIndex}
          />
        ))
      );
    }
    return allWrappedElements;
  };
  return (
    <div styleName="story-card" key={card.id} id={card.id} className="story-card">
      {wrappedAllElementCard(elements, story).map((element, elementIndex) => {
        const elementType = element?.props?.children?.props?.element?.type;
        return (
          <React.Fragment key={elementIndex}>
            <React.Fragment>{element}</React.Fragment>

            {cardIndex === 0 && elementIndex === 0 && elementType !== "text" ? (
              <div styleName="ad-wrapper">
                {isMobile ? (
                  <AdContainer
                    AdClassName="standard-336x280"
                    id={adType === "izooto" ? "div-gpt-ad-1711631172416-0" : "div-gpt-ad-1675837516069-0"}
                    mobile={adType === "izooto" ? "PV_MWeb_AP_Mid_ym" : "PV_MWeb_AP_Mid"}
                    isExternalAdPath={adType === "izooto"}
                  />
                ) : (
                  <AdContainer
                    AdClassName="standard-336x280"
                    id={adType === "izooto" ? "div-gpt-ad-1711630758806-0" : "div-gpt-ad-1675837516069-0"}
                    desktop={adType === "izooto" ? "PV_Desktop_AP_Mid_ym" : "PV_Desktop_AP_Mid"}
                    isExternalAdPath={adType === "izooto"}
                  />
                )}
              </div>
            ) : null}
          </React.Fragment>
        );
      })}
    </div>
  );
};

const StoryElements = ({
  story,
  index,
  cards,
  isPodcast = false,
  isFactCheck,
  isMovieReview,
  isGadgetReview,
  isSponsoredStory
}) => {
  const template = story["story-template"] ? story["story-template"] : "text";
  const [renderTaboolaAd, setRenderTaboolaAd] = useState(true);
  const [renderAd, setRenderAd] = useState(false);
  const isMobile = useDevice();
  const adType = useAdType();

  useEffect(() => {
    setTimeout(() => {
      setRenderAd(true);
    }, 200);
  }, []);

  return (
    <div styleName="wrapper">
      {isMovieReview && <MovieReviewView story={story} />}
      {isGadgetReview && <GadgetReviewView story={story} />}
      <div
        id={`story-content-${story.id}`}
        className={`story-cards ${
          template !== "subhashita" && template !== "cartoon" && template !== "nammakshetra-namma-ooru"
            ? "taboola-read-more-container"
            : ""
        }`}
      >
        {cards.map((card, cardIndex) => (
          <StoryCard card={card} story={story} key={card.id} cardIndex={cardIndex} index={index} />
        ))}

        {isPodcast && story["first-published-at"] > 1682569800000 ? <PodcastBody /> : null}
        {isFactCheck && <FactCheckView story={story} />}
        <Tags story={story} />
        <PromotionalMessage story={story} />
        {isSponsoredStory && <SponsoredTag />}
        {index === 0 ? (
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer
              AdClassName="standard-336x280"
              id={adType === "izooto" ? "div-gpt-ad-1711631239725-0" : "div-gpt-ad-1675837544367-0"}
              mobile={adType === "izooto" ? "PV_MWeb_AP_Bottom_ym" : "PV_MWeb_AP_Bottom"}
              isExternalAdPath={adType === "izooto"}
            />
          </div>
        ) : null}

        {isMobile ? (
          <div>
            <WithLazy margin="300px">{() => <LatestNews story={story} />}</WithLazy>
          </div>
        ) : (
          <div className="more-news-section">
            <MoreNews story={story} />
          </div>
        )}
      </div>
      {renderTaboolaAd ? (
        <TaboolaAd
          container={`taboola-below-article-${story.id}`}
          placement="Below Article Thumbnails"
          mode="thumbnails-e"
        />
      ) : null}
      {template !== "sponsored" && <div styleName="temp-ad"></div>}
    </div>
  );
};

StoryElements.defaultProps = {
  isPodcast: false,
  isFactCheck: false,
  isMovieReview: false,
  isGadgetReview: false,
  isSponsoredStory: false
};

export default StoryElements;
